import * as React from "react";
import { renderAppPreviewGallery } from "./renderAppPreviewGallery";
import type {
  AppPreviewGalleryProps,
  NeededPropsFromAppGalleryButton,
} from "./AppPreviewGallery.types";
import { useAppPreviewGallery } from "./useAppPreviewGallery";
import type { ForwardRefComponent } from "@fluentui/react-components";
import { useAppPreviewGalleryStyles } from "./useAppPreviewGalleryStyles.styles";

export const AppPreviewGallery: ForwardRefComponent<
  AppPreviewGalleryProps<NeededPropsFromAppGalleryButton>
> = React.memo(
  React.forwardRef<
    HTMLDivElement,
    AppPreviewGalleryProps<NeededPropsFromAppGalleryButton>
  >((props, ref) => {
    const state = useAppPreviewGallery(props, ref);

    useAppPreviewGalleryStyles(state);
    return renderAppPreviewGallery(state);
  })
) as ForwardRefComponent<
  AppPreviewGalleryProps<NeededPropsFromAppGalleryButton>
>;

AppPreviewGallery.displayName = "next/AppPreviewGallery";
